

























import Vue from 'vue';
import { BModal, BRow, BCol, BLink, BImg } from 'bootstrap-vue';

export default Vue.extend({
  data: () => ({
    show: false,
    title: '',
    text: '',
    url: '',
  }),
  computed: {
    twitterUrl() {
      const query = new URLSearchParams();
      query.set('text', this.text);
      query.set('url', this.url);
      query.set('via', 'mblonyox');
      query.set('related', '9gag:Official 9GAG');
      return `https://twitter.com/intent/tweet?${query.toString()}`;
    },
    facebookUrl() {
      const query = new URLSearchParams();
      query.set('title', this.title);
      query.set('description', this.text);
      query.set('u', this.url);
      return `https://www.facebook.com/sharer/sharer.php?${query.toString()}`;
    },
    emailUrl() {
      const query = new URLSearchParams();
      query.set('subject', this.title);
      query.set('body', `${this.text} - ${this.url}`);
      return `mailto:?${query.toString()}`;
    },
  },
  methods: {
    onShare(data: { title: string; text: string; url: string }) {
      this.title = data.title;
      this.text = data.text;
      this.url = data.url;
      this.show = true;
    },
  },
  created() {
    this.$root.$on('share::post', this.onShare);
  },
  beforeDestroy() {
    this.$root.$off('share::post', this.onShare);
  },
  components: { BModal, BRow, BCol, BLink, BImg },
});
